import React from 'react';
import { Input, Button, Space } from 'antd';

export default class TextFilter extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			searchText: '',
			searchedColumn: '',
		};
	}

	onSearch = () => {
		this.setState(
			{
				searchText: this.props.selectedKeys,
				searchedColumn: this.props.dataIndex,
			},
			() => this.props.confirm()
		);
	};

	onReset = () => {
		this.setState({ searchText: '' }, () => this.props.clearFilters());
	};

	render() {
		return (
			<div style={{ padding: 8 }}>
				<Input style={{ width: 143, marginBottom: 8, display: 'block' }} value={this.props.selectedKeys} onChange={(e) => this.props.setSelectedKeys(e.target.value)} onPressEnter={this.onSearch} />
				<Space style={{ display: 'flex', justifyContent: 'space-between' }}>
					<Button size='small' onClick={this.onReset} type='link'>
						Reset
					</Button>
					<Button type='primary' size='small' onClick={this.onSearch}>
						Search
					</Button>
				</Space>
			</div>
		);
	}
}
